import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { LogService } from './services/log.service';
import { Environment } from '@env/environment';
import { LOCAL_STORAGE, SESSION_STORAGE } from './services/storage';
import { AppErrorHandler } from './services/app-error-handler';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth-interceptor';
import { AuthComponent } from './components/auth/auth.component';
import { LandingComponent } from './components/landing/landing.component';
import { ErrorComponent } from './components/error/error.component';
import { LoadingIndicatorService } from './services/loading-indicator.service';

@NgModule({
	declarations: [AuthComponent, LandingComponent, ErrorComponent],
	imports: [],
	exports: [AuthComponent],
	providers: [
		LogService,
		LoadingIndicatorService,
		{ provide: LOCAL_STORAGE, useValue: localStorage },
		{ provide: SESSION_STORAGE, useValue: sessionStorage },
	],
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) throw new Error('CoreModule is already loaded. Do not import it below the level of AppModule.');
	}
}
